import { useTranslation } from "react-i18next";
import PrimaryButton from "components/button/primaryButton";
import MapPinRangeFillIcon from "remixicon-react/MapPinRangeFillIcon";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import cls from "./home-actions.module.scss";

const HomeFilter = dynamic(() => import("components/home-filter/home-filter"));

export default function HomeActions() {
  const { t } = useTranslation();
  const { push } = useRouter();

  return (
    <div className={cls.container}>
      <HomeFilter />
      <div className={cls.viewInMap}>
        <PrimaryButton
          icon={<MapPinRangeFillIcon size={20} />}
          fullWidth={false}
          onClick={() => push("/shops-in-map")}
          rounded={false}
        >
          {t("view.in.map")}
        </PrimaryButton>
      </div>
    </div>
  );
}
